/**
 * Décide comment ouvrir un fichier partagé à partir de la réponse du back. Le back ne renvoie une
 * `previewUrl` que pour les types qu'un navigateur sait afficher ; sinon un onglet resterait blanc,
 * l'URL de téléchargement étant signée en pièce jointe.
 */
export type SharedResourceOpening = { mode: 'preview' | 'download'; url: string };

export function resolveSharedResourceOpening(
  result: { downloadUrl?: string | null; previewUrl?: string | null } | null | undefined,
): SharedResourceOpening | null {
  if (!result?.downloadUrl) return null;
  if (result.previewUrl) return { mode: 'preview', url: result.previewUrl };
  return { mode: 'download', url: result.downloadUrl };
}

/**
 * L'onglet doit être ouvert au clic, avant de connaître la réponse du back : on tranche sur le type
 * de la ressource. Un PDF n'est affichable que par un navigateur doté d'une visionneuse (faux sur
 * Chrome Android), sinon il se télécharge et l'onglet resterait blanc devant le spectateur.
 */
export function canPreviewInTab(mimeType: string | null | undefined, pdfViewerEnabled: boolean) {
  if (!mimeType) return false;
  const type = mimeType.split(';')[0].trim().toLowerCase();
  if (type === 'image/svg+xml') return false;
  if (type.startsWith('image/')) return true;
  if (type === 'application/pdf') return pdfViewerEnabled;
  return false;
}
